import api from "../http";

export default class ExpensesAPI {
    static async getAll(isAdmin) {
        // -1 - all, 0 - all, 1 - admin 
        // return api.get('/expense/' + isAdmin && isAdmin === 1 ? '?isAdmin=1' : ''); 
        return api.get('/expense/'); 
    }

    static async create(item) {
        return api.post('/expense/', item);
    }

    static async update(item) {
        return api.post('/expense/edit', item);
    }

    static async remove(id) {
        return api.get('/expense/remove?id=' + id);
    }
}